import React, { useState } from 'react';
import { EllipsisIcon, MinusIcon, PlusIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import Popover from '@rsos/components/capstone/base/Popover';
import { ActionsBox, ActionButton } from './TF911.styles';
import TF911ChatParticipants from './TF911ChatParticipants';

/**
 * Popover component that shows a Text-From-911 chat's participants
 * @param {Boolean} showStartChat - Flag for rendering this component
 * @param {Array} participants - List of participants for a Text-From-911 chat
 * @param {Boolean} isChatBoxVisible - Flag for expanding/collapsing the chat
 * @param {Function} onActionButtonClick - Onclick handler for toggling the
 * isTextFrom911ChatBoxVisible flag
 */
const TF911ParticipantsPopover = ({
  showStartChat,
  participants,
  isChatBoxVisible,
  onActionButtonClick,
}) => {
  // TODO: useSelector for callParticipants
  const [isParticipantsPopoverOpen, setIsParticipantsPopoverOpen] = useState(
    false,
  );

  if (showStartChat) {
    return null;
  }
  return (
    <Box>
      <ActionsBox>
        {/* TODO: PSX-3972 */}
        {/* <ActionButton
          onMouseEnter={() => setIsParticipantsPopoverOpen(true)}
          onMouseLeave={() => setIsParticipantsPopoverOpen(false)}
        >
          <Popover
            cssDisplayProperty="block"
            isOpen={isParticipantsPopoverOpen}
            popoverID={`chat-popover`}
            trigger={
              <EllipsisIcon width={12} height={12} color="secondaryText" />
            }
            useCustomOffset
            xOffset={-6}
            yOffset={20}
          >
            <TF911ChatParticipants callChatParticipants={participants} />
          </Popover>
        </ActionButton> */}
        <ActionButton noMargin showBorder onClick={onActionButtonClick}>
          {!isChatBoxVisible ? (
            <PlusIcon width={14} height={14} color="secondaryText" />
          ) : (
            <MinusIcon width={12} height={12} color="secondaryText" />
          )}
        </ActionButton>
      </ActionsBox>
    </Box>
  );
};

export default TF911ParticipantsPopover;
